import { createAsyncAction } from 'async-selector-kit'
import { API_PATH_PROFILE_CREATE } from '../../../../config'
import { RootState } from '../../../../store'
import { ApiConfig, getLocalServerURL } from '../../../../utils/getApiConfig'
import { onIsLoading } from '../../../../utils/onLoading'
import { actions as appActions } from '../../../App/reducer'
import { onError } from '../../../../utils/onError'
import { onSuccess } from '../../../../utils/onSuccess'

export type StoreLike = { getState: () => RootState; dispatch: (action: unknown) => void }

/**
 * Core profile create logic. Exported for testing (success, error).
 */
export async function executeCreateProfile(
  store: StoreLike,
  config: ApiConfig
): Promise<void> {
  const PATH = getLocalServerURL(API_PATH_PROFILE_CREATE)
  onIsLoading(true)
  try {
    const response = await fetch(PATH, config)
    if (!response.ok) {
      onError('Failed to create profile')
      return
    }
    const data = await response.json()
    if (data?.messages?.resultCode === 'Ok') {
      onSuccess('Successfully created profile')
      store.dispatch(appActions.onCustomerProfileId(data.customerProfileId))
    } else {
      const error = data?.messages?.message?.[0]?.text || 'Unknown error'
      onError(error)
      store.dispatch(appActions.onCustomerProfileId(undefined))
    }
  } finally {
    onIsLoading(false)
  }
}

export const [createProfile, _, createProfileError] = createAsyncAction(
  {
    id: 'create-profile',
    async: (store) => async (config: ApiConfig) => {
      await executeCreateProfile(store, config)
    },
  },
  []
)
